import { cloneElement, isValidElement, useRef } from 'react';

import { dispatchEvent, EventKey } from '@tgg/services';

import withVerticalSpacing from '../../hocs/withVerticalSpacing';
import { SimpleCarousel } from '../SimpleCarousel';

import { useUpdatePromoTitleHeights } from './PromoCardLayout.hook';
import {
    StyledContainer,
    StyledPromoCardLayout,
} from './PromoCardLayout.styled';
import { PromoCardLayoutProperties } from './PromoCardLayout.types';

export const PromoCardLayoutComponent = ({
    id,
    content,
    withScrollbar,
}: PromoCardLayoutProperties) => {
    const numberOfChildren = content.length;
    const layoutReference = useRef<HTMLDivElement>(null);
    const mappedContent = content.map(element => {
        /* istanbul ignore next */
        if (!isValidElement<{ schema: { isSlim: boolean } }>(element))
            return element;

        const newSchema = {
            ...element.props.schema,
            isCarouselChild: withScrollbar,
        };

        return cloneElement(element, {
            ...element.props,
            schema: newSchema,
        });
    });

    useUpdatePromoTitleHeights(layoutReference, content);

    return withScrollbar ? (
        <SimpleCarousel
            galleryElements={mappedContent}
            areSlidesSameWidth
            onFirstScroll={() => dispatchEvent(EventKey.PROMO_CAROUSEL_SCROLL)}
            id="promoCardCarousel"
            isNewDesign
        />
    ) : (
        <StyledContainer id={id ?? 'promo-cards'}>
            <StyledPromoCardLayout
                data-testid="promo-card-layout"
                data-count={numberOfChildren}
                ref={layoutReference}
            >
                {content}
            </StyledPromoCardLayout>
        </StyledContainer>
    );
};

export const PromoCardLayout = withVerticalSpacing(PromoCardLayoutComponent);
